<template>
    <el-dialog
        class="person-permission-dialog"
        :close-on-click-modal="closeOnClickModal"
        :visible.sync="openPermissionDialog"
        top="4%"
        width="1000px"
        :before-close="closeDialog">
        <div slot="title" class="dialog-title">
            <span>权限配置</span>
            <span class="ppd-title-tip">分配权限保存15分钟后，刷新供应商平台(LSP)权限生效</span>
        </div>
        <div class="dialog-body">
            <el-tabs :tab-position="'left'" style="height: 100%;" v-model="roleOrData">
                <el-tab-pane label="角色权限" :name="ONE" class="tab-role">
                    <div class="role-title">请选择角色（可多选）
                        <el-button type="primary" class="save-button" @click="handleSaveRoles">保 存</el-button>
                    </div>
                    <el-checkbox-group v-model="roles" class="role-checkbox" @change="checkRolesChange">
                        <el-checkbox v-for="(item, index) in rolesList"
                                     :label="item.value"
                                     :key="index">{{item.label}}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-tab-pane>
                <el-tab-pane label="数据权限" :name="TWO" class="tab-data">
                    <el-tabs :tab-position="'top'" style="height: 100%;" v-model="dataPermission">
                        <el-tab-pane v-for="(item, index) in dataList"
                                     :key="index"
                                     :label="item.label"
                                     :name="item.name"
                                     style="height: 100%;">
                            <data-permission :dataCode="item.value"
                                             v-bind="$attrs"
                                             :row="row">
                            </data-permission>
                        </el-tab-pane>
                    </el-tabs>
                </el-tab-pane>
            </el-tabs>
        </div>
        <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="closeDialog">关 闭</el-button>
  </span>
    </el-dialog>
</template>
<script>
import dataPermission from './DataPermission.vue';
import { ONE, TWO, THREE } from '../../../../../../constant/constant.js';
import { getMainUserGrantRoles, getSubUserGrantRoles, submitRole } from '../../../../../../api/register/person.js';
import { getDictionary } from '../../../../../../utils/getDictionary.js';

export default {
    inheritAttrs: false,
    name: 'permission-dialog',
    components: { dataPermission },
    props: {
        openPermissionDialog: {
            type: Boolean,
            default() {
                return false;
            }
        },
        row: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            closeOnClickModal: false,
            ONE,
            TWO,
            THREE,
            roleOrData: ONE,
            dataPermission: ONE,
            roles: [],
            rolesList: [], // 角色权限数据字典
            dataList: [], // 数据权限数据字典
            dataSubmitData: []
        };
    },
    methods: {
        checkRolesChange() {},
        closeDialog() {
            this.handleRecoverDialog();
            this.$emit('closeDialog', false);
        },
        handleSaveRoles() {
            const params = this.handleRolesSubmitData();
            submitRole(JSON.stringify(params)).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('保存成功！');
                }
            });
        },
        handleRolesSubmitData() {
            const submitForm = {};
            const rolesList = [];
            this.rolesList.forEach(e => {
                rolesList.push({
                    roleCode: e.value,
                    roleName: e.label,
                    selectedFlag: '0',
                    userCode: this.row.userCode,
                    tenantCode: this.$store.state.currentTenant.tenantCode,
                    applicationCode: this.$store.state.applicationCode
                });
            });
            rolesList.forEach(e => {
                this.roles.forEach(el => {
                    if (e.roleCode === el) {
                        e.selectedFlag = '1';
                    }
                });
            });
            submitForm.roleUserSelectDtos = rolesList;
            return submitForm;
        },
        handleRecoverDialog() {
            this.roleOrData = ONE;
            this.dataPermission = ONE;
        },
        handleGetRoles() {
            const row = {
                userCode: this.row.userCode
            };
            this.roles = [];
            if (this.row.userType === '1') { // 主账号
                getMainUserGrantRoles(row).then(res => {
                    if (res && res.code === '0') {
                        res.data.list.forEach(e => {
                            if (String(e.selectedFlag) === '1') {
                                this.roles.push(e.roleCode);
                            }
                        });
                    }
                });
                return;
            }
            if (this.row.userType === '2') { // 子账号
                this.rolesList = [];
                getSubUserGrantRoles(row).then(res => {
                    if (res && res.code === '0') {
                        res.data.list.forEach(e => {
                            this.rolesList.push({
                                value: e.roleCode,
                                label: e.roleName
                            });
                            if (String(e.selectedFlag) === '1') {
                                this.roles.push(e.roleCode);
                            }
                        });
                    }
                });
            }
        }
    },
    watch: {
        openPermissionDialog(nVal) {
            if (nVal) {
                getDictionary('SRM_PORTAL_ROLE', this.$store.state.currentTenant.tenantCode).then(res => {
                    this.rolesList = res;
                    this.handleGetRoles();
                });
                getDictionary('SRM_PORTAL_DATA_AUTH').then(res => {
                    this.dataList = res;
                    this.dataList.forEach((item, index) => {
                        item.name = String(index + 1);
                    });
                });
            }
        }
    }
};
</script>

<style lang="less" src="./permissionDialog.less"></style>
